<template>
  <div>
    <div class="notice-list mt20 mb20" style="margin-right: 10px !important;">
      <el-tabs class="notice-list-tabs">
        <!--评标结果-->
        <el-tab-pane label="评标结果" class="notice-list-group clearfix">
          <template v-for="(item, index) in nodeList3">
            <div class="block" @click="handleViewDetail(item, 3)" :key="index">
              <div :title="item.noticeTitle">{{ item.noticeTitle }}</div>
              <div>
                {{
                  item.noticeStartTime
                    ? moment(item.noticeStartTime).format("YYYY-MM-DD")
                    : ""
                }}
              </div>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-link
        :underline="false"
        type="info"
        style="transform: translateY(5px)"
        class="notice-list-view-all"
        @click="handleViewAll('3')"
        >更多 ></el-link
      >
    </div>
    <div class="notice-list mt20 mb20" style="margin-right: 10px !important;">
      <el-tabs class="notice-list-tabs">
        <!--中标通知-->
        <el-tab-pane label="中标通知" class="notice-list-group clearfix">
          <template v-for="(item, index) in nodeList4">
            <div class="block" @click="handleViewDetail(item, 4)" :key="index">
              <div class="ellipsis" :title="item.noticeTitle">
                {{ item.noticeTitle }}
              </div>
              <div>
                {{
                  item.noticeStartTime
                    ? moment(item.noticeStartTime).format("YYYY-MM-DD")
                    : ""
                }}
              </div>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-link
        :underline="false"
        type="info"
        style="transform: translateY(5px)"
        class="notice-list-view-all"
        @click="handleViewAll('4')"
        >更多 ></el-link
      >
    </div>
    <div class="notice-list mt20 mb20">
      <el-tabs class="notice-list-tabs">
        <!--业务公告-->
        <el-tab-pane label="业务公告" class="notice-list-group clearfix">
          <template v-for="(item, index) in pageData">
            <div class="block" @click="handleOp(item)" :key="index">
              <div class="ellipsis" :title="item.title">{{ item.title }}</div>
              <div>
                {{
                  item.publishTime
                    ? moment(item.publishTime).format("YYYY-MM-DD")
                    : ""
                }}
              </div>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-link
        :underline="false"
        type="info"
        class="notice-list-view-all"
        @click="handleViewAll('业务')"
        style="transform: translateY(5px)"
        >更多 ></el-link
      >
    </div>
  </div>
</template>

<script>
import {
  listSupBidNotice,
  queryPublishedNoticeList
} from "@/app/procurementNotice/api/shopping";
import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
import Cookies from "js-cookie";
import moment from "moment";
export default {
  name: "noticeList",
  mixins: [mixinHomePage],
  data() {
    return {
      nodeList3: [],
      nodeList2: [],
      nodeList4: [],
      nodeList7: [],
      nodeList8: [],
      pageData: [],
      moment: moment,
      loginInfo: this.$store.state.user.loginInfo || {},
      supOrPur: ""
    };
  },
  mounted() {},
  activated() {
    this.init();
  },
  methods: {
    init() {
      if (
        this.supInfo.getSupInfoByLoginInfoRspBOList &&
        this.supInfo.getSupInfoByLoginInfoRspBOList.length > 0
      ) {
        this.supOrPur = "sup";
      } else {
        this.supOrPur = "pur";
      }
      this.getNoticeList({
        noticeType: 3
      });
      this.getNoticeList({
        noticeType: 4
      });
      this.publicNotice();
    },
    publicNotice() {
      queryPublishedNoticeList({
        pageNo: 1,
        pageSize: 5,
        module: 1,
        pageState: 2,
        textType: 3,
        appId: 100123
      }).then(res => {
        if (res.data.code === "0") {
          // this.pageData = res.data.data.rows.filter(item => {
          //   return item.textType == 3;
          // });
          this.pageData = res.data.data.rows;
        }
      });
    },
    getNoticeList(obj) {
      let supCodeList = [];
      if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      }
      let params = {
        noticeStatusEndFlag: 1,
        pageNo: 1,
        pageSize: 5,
        supCodeList: supCodeList
      };
      if (
        Cookies.get("language") !== undefined &&
        Cookies.get("language") !== "zh-cn"
      ) {
        params.overseasSupFlag = 1;
      }
      Object.assign(params, obj);
      listSupBidNotice(params).then(res => {
        if (res.data.code === "0") {
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.$set(this, "nodeList" + params.noticeType, res.data.data.rows);
          }
        }
      });
    },
    isLogin() {
      if (Cookies.get("access_token")) {
        return true;
      } else {
        this.$message({
          message: "您尚未登录 请先登录",
          type: "warning",
          offset: document.documentElement.clientHeight / 2 - 21
        });
        return false;
      }
    },
    handleOp(row) {
      // let url = this.$router.resolve({
      //   path: "/announcementDetail",
      //   query: {
      //     id: row.noticeInfoId,
      //     type: this.type
      //   }
      // });
      let params = ["id=" + row.noticeInfoId];
      let url = "/announcementDetail?" + params.join("&");
      window.open(url, "_blank");
    },
    handleViewDetail(row, type) {
      let url = this.$router.resolve({
        path: "/viewNoticeSimpleDetail",
        query: {
          type: type,
          schemeId: row.schemeId,
          schemeName: row.schemeName,
          schemeCode: row.schemeCode,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          supCode: row.supCode,
          supName: row.supName
        }
      });
      // let params = [
      //   "type=" + this.tabName,
      //   "schemeId=" + row.schemeId,
      //   "schemeName=" + row.schemeName,
      //   "schemeCode=" + row.schemeCode,
      //   "noticeId=" + row.noticeId,
      //   "opUnitName=" + row.opUnitName,
      //   "supCode=" + row.supCode,
      //   "supName=" + row.supName
      // ];
      // let url = "/viewNoticeSimpleDetail?" + params.join("&");
      // window.open(window.location.origin + url, "_blank");
      window.open(url.href, "_blank");
    },
    handleViewAll(type) {
      if (type === "2") {
        //邀请公告
        // let params = ["type=" + type];
        // let url = "/searchList?" + params.join("&");
        // window.location.href =
        //   this.$addUrlPerFix(process.env.VUE_APP_SP_URL) +
        //   url +
        //   "&isJRZL=1&searchType=采购公告";
        // let url = this.$router.resolve({
        //   path: "/searchList",
        //   query: {
        //     type: type
        //   }
        // });
        // window.open(url.href, "_blank");
        this.$router.push({
          path: "/searchList",
          query: {
            type: type
          }
        });
      } else if (type == "业务") {
        // let url = "/announcementsList?textType=3";
        // window.location.href =
        //   this.$addUrlPerFix(process.env.VUE_APP_SP_URL) +
        //   url +
        //   "&isJRZL=1&searchType=采购公告";
        // window.open(url, "_blank");
        // let url = this.$router.resolve({
        //   path: "/announcementsList"
        // });
        // window.open(url.href, "_blank");
        this.$router.push({
          path: "/announcementsList",
          query: {
            textType: 3
          }
        });
      } else {
        // let params = ["type=" + type, "source=1"];
        // let url = "/announcementsList?" + params.join("&");
        // window.location.href =
        //   this.$addUrlPerFix(process.env.VUE_APP_SP_URL) +
        //   url +
        //   "&isJRZL=1&searchType=采购公告";
        // window.open(url, "_blank");
        // let url = this.$router.resolve({
        //   path: "/announcementsList",
        //   query: {
        //     type: type,
        //     source: "1"
        //   }
        // });
        // window.open(url.href, "_blank");
        this.$router.push({
          path: "/announcementsList",
          query: {
            type,
            source: "1"
          }
        });
      }
    }
  },
  computed: {
    showNoticeTitle() {
      return item => {
        //       return item => {https://docs.qq.com/sheet/DQkdUaFNHenVIc0VY?tab=jw2dyn 68行
        // if (item.supName) {
        //   return `[${item.supName}]${item.noticeTitle}`;
        // } else {
        //   return item.noticeTitle;
        // }
        return item.noticeTitle;
      };
    },
    supInfo() {
      return this.$store.state.user.supInfo || {};
    }
  },
  watch: {
    // tabName(val) {
    //   switch (val) {
    //     case "3": //评标结果
    //       this.getNoticeList({
    //         noticeType: 3,
    //       });
    //       break;
    //     case "2": //邀请公告
    //       if (this.isLogin()) {
    //         this.getNoticeList({
    //           noticeType: 2,
    //         });
    //       }
    //       break;
    //     case "4": //中标通知
    //       if (this.isLogin()) {
    //         this.getNoticeList({
    //           noticeType: 4,
    //         });
    //       }
    //       break;
    //     case "7": //补遗公告
    //       this.getNoticeList({
    //         noticeType: 7,
    //         purSupFlag: this.supOrPur,
    //       });
    //       break;
    //     case "8": //流标公告
    //       this.getNoticeList({
    //         noticeType: 8,
    //         purSupFlag: this.supOrPur,
    //       });
    //       break;
    //   }
    // },
  }
};
</script>

<style scoped lang="scss">
.mt20 {
  margin-top: 20px;
}
/deep/.notice-list .notice-list-group a:nth-child(2n) {
  margin-left: 0 !important;
}
/deep/.notice-list {
  width: 50% !important;
  float: left;
}
.notice-list {
  width: 386px !important;
  height: 248px !important;
  .block {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    cursor: pointer;
    div:first-child {
      width: 247px;
      height: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #4a4a4a;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &:hover {
        color: #0089ef;
      }
    }
    div:last-child {
      width: 74px;
      height: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #999999;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      &:hover {
        color: #0089ef;
      }
    }
  }
}
</style>
